<template>
  <v-tabs :value="value" @change="$emit('input',$event)"  :background-color="background" :dark="dark" :vertical="vertical">
    <slot />
  </v-tabs>
</template>

<script>
import EdFormMixin from "./mixins/formControl";

export default {
  name: "EdTabs",
  mixins: [EdFormMixin],
  components: {},
  props: {
    background:{
      type:String,
      required:false,
      default:''
    },
    dark:{
      type:Boolean,
      required:false,
      default:false
    },
    vertical:{
      type:Boolean,
      required:false,
      default:false
    }
  },
  data() {
    return {};
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/components/template/EdTabs.vue